import React from 'react';
import { useLandingPageState, useLandingPageActions } from './LandingPageContext';
import { useCapabilities } from '../../Shared/capabilities';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import Button from '../../Shared/UI/Button/components/Button';
import styles from './LandingPage.module.scss';

const SplashSection = () => {
  const state = useLandingPageState();
  const { openInvitationRequestWizard } = useLandingPageActions();
  const capabilities = useCapabilities();

  return (
    <section id={styles.splash} style={state?.sharedAssetsPaths?.ecosystem ? {backgroundImage: `url(${state.sharedAssetsPaths.ecosystem})`} : {}}>
      <p id={styles.introduction}>A professional network for people in biology, biotech, and pharma.</p>
      {capabilities.showRequestInvitationNavigation && (
        <ResponsiveContainer
          name="action-row"
        >
          <ActionRow
            align='center'
          >
            <Button
              variant="primary"
              size="inherit"
              onClick={openInvitationRequestWizard}
            >
              Request an Invitation
            </Button>
          </ActionRow>
        </ResponsiveContainer>
      )}
    </section>
  );
};

export default SplashSection;